import { css } from "@emotion/css"

import NumberField from "@p-ban/common/src/components/form/NumberField/NumberField"
import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"
import Spacer from "@p-ban/common/src/components/layout/Spacer"
import useDebounce from "@p-ban/common/src/hooks/useDebounce"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisabledCondition from "../../../../../service/getDisabledCondition"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import FieldSet from "../../../../components/1Click/FieldSet"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import DisabledOverlay from "../../../../components/1Click/overlay/DisabledOverlay"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./pieceCnt.png"

const 表面実装部品 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const condition = getDisplayCondition(values)
  const disabled = getDisabledCondition(values)
  const shouldShow = condition.pieceCnt || condition.bgacsp || condition.sideOfSmd

  const onUpdatePieceCnt = useDebounce(handlers.number)
  const onUpdateBgacsp = useDebounce(handlers.number)

  return (
    <OneClickField isShow={shouldShow} legend="表面実装部品" helpURL={HELP_LINKS.表面実装部品} src={img} mapChildren>
      <>
        <label>
          <span className={style}>表面実装部品（SMD一般）</span>
          <NumberField
            name={FIELD_NAMES.表面実装部品}
            value={values.pieceCnt}
            onUpdateValue={onUpdatePieceCnt}
            min={0}
            max={9999}
            maxDecimalDigits={0}
            step={1}
            suffix="点／枚"
            error={!!errors?.pieceCnt}
          />
        </label>
        <OneClickFieldMessages error={errors?.pieceCnt} />
        <Spacer size={8} />
        <label>
          <span className={style}>本体下に端子が隠れている部品（BGA/CSP/LGA/QFN/Exposed-Padがある部品）</span>
          <NumberField
            name={FIELD_NAMES.本体下に端子が隠れている部品}
            value={values.bgacsp}
            onUpdateValue={onUpdateBgacsp}
            min={0}
            max={9999}
            maxDecimalDigits={0}
            step={1}
            suffix="点／枚"
            error={!!errors?.bgacsp}
          />
        </label>
        <OneClickFieldMessages error={errors?.bgacsp} />
      </>
      <>
        <FieldSet legend="実装面">
          <RadioGroup
            name={FIELD_NAMES["実装面 SMD"]}
            selectedValue={values.sideOfSmd}
            onChange={handlers.radio}
            disabled={disabled.sideOfSmd}
          >
            <OneClickFieldStack>
              <Radio value={ESTIMATE_CONSTANT["実装面 SMD"].部品面.value}>部品面</Radio>
              <Radio value={ESTIMATE_CONSTANT["実装面 SMD"].半田面.value}>半田面</Radio>
              <Radio value={ESTIMATE_CONSTANT["実装面 SMD"].両面.value}>両面</Radio>
            </OneClickFieldStack>
          </RadioGroup>
          <OneClickFieldMessages error={errors?.sideOfSmd} />
        </FieldSet>
        {disabled.sideOfSmd && <DisabledOverlay />}
      </>
    </OneClickField>
  )
}

export default 表面実装部品

const style = css`
  display: block;
  padding-bottom: 8px;
  font-size: 13px;
  line-height: 14px;
`
